/* eslint-disable class-methods-use-this */
/* eslint-disable react/self-closing-comp */
/* eslint-disable no-trailing-spaces */
import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Helmet } from 'react-helmet';
import { ABOUT_TITLE, ABOUT_DESCRIPTION } from '../../Utils/Constants/SEO';
import './css/About.css';
import {
  ABOUT_TOURHUNTER,
  WHY_TORHUNTER,
  HOW_TO_BUY,
  KEY_FACES,
  OUR_TEAM,
} from '../../Utils/Constants/GlobalConstants';
import Tour from '../../images/tour-r.png';
import Support from '../../images/support-r.png';
import Price from '../../images/blue-price.png';
import Flight from '../../images/flight.png';
import { ReactComponent as GrayTriange } from '../../images/gray_triangle.svg';
import { ReactComponent as BlueTriange } from '../../images/blue_triangle.svg';

class About extends React.Component {
  constructor(props) {
    super(props);

    this.whyTourhunterNode = React.createRef();
    this.howToBuyNode = React.createRef();
    this.ourTeamNode = React.createRef();

    this.state = {};
  }

  scrollTo = (node) => {
    node.current.scrollIntoView({
      behavior: 'smooth',
    });
  };

  render() {
    return (
      <div>
        <Helmet>
          <title>{ABOUT_TITLE}</title>
          <meta name="description" content={ABOUT_DESCRIPTION} />

          <meta property="og:site_name" content="TourHunter.by" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://tourhunter.by/about/" />
          <meta property="og:title" content={ABOUT_TITLE} />
          <meta property="og:description" content={ABOUT_DESCRIPTION} />
          <meta
            property="og:image"
            content="https://tourhunter.by/file/thr_logo.png"
          />

          <link rel="canonical" href="https://tourhunter.by/about/" />
        </Helmet>
        <div className="ab_banner_w">
          <div className="containerW ab_banner_content">
            <div className="ab_banner_title">{ABOUT_TOURHUNTER}</div>
            <div className="ab_content_menu_w">
              <button
                type="button"
                className="wm_text_18 ab_menu_item"
                onClick={() => {
                  this.scrollTo(this.whyTourhunterNode);
                }}
              >
                {WHY_TORHUNTER}
              </button>
              <button
                type="button"
                className="wm_text_18 ab_menu_item"
                onClick={() => {
                  this.scrollTo(this.howToBuyNode);
                }}
              >
                {HOW_TO_BUY}
              </button>
              <button
                type="button"
                className="wm_text_18 ab_menu_item"
                onClick={() => {
                  this.scrollTo(this.ourTeamNode);
                }}
              >
                {OUR_TEAM}
              </button>
            </div>
          </div>
        </div>
        <div className="containerW">
          <div className="ab_section_w">
            <div
              className="ab_section_text_w"
              ref={(node) => {
                this.whyTourhunterNode.current = node;
              }}
            >
              <h1 className="ab_section_title">
                Почему выбирают <span className="ab_blue_name">TourHunter</span>
              </h1>
              <div className="ab_section_text">
                Туры стоят денег, а ваше время — бесценно. Экономьте и то, и
                другое! Выбирайте готовый тур онлайн за пару кликов. Мы обо всем
                позаботимся: ответим на все вопросы по телефону и отправим
                документы на email. Отдыхайте легко с TourHunter!
              </div>
            </div>

            <div className="ab_benefits_w">
              <div className="ab_benefits_col1">
                <div className="mb_30">
                  <div className="ab_benefit_section_gray section_gray_top">
                    <img src={Tour} alt="" className="mb_10 ab_ben_ico" />
                    <div className="ab_benefit_title_b">Выгодно</div>
                    <div className="ab_benefit_text_b">
                      Больше не нужно обзванивать агентства. Лучшие предложения
                      от всех туроператоров уже ждут вас здесь
                    </div>
                  </div>
                  <div className="ab_triangle">
                    <GrayTriange />
                  </div>
                </div>
                <div className="ab_benefit_section_gray mb_16 section_gray_bottom">
                  <div className="ab_benefit_secont_title_b">
                    СРАВНИВАЙТЕ ЦЕНЫ
                  </div>
                  <div className="ab_benefit_text_b">
                    Забудьте о долгих поисках. Мы делаем это за вас: сравниваем
                    цены от 20 туроператоров онлайн и показываем лучшие за 5
                    секунд
                  </div>
                </div>
                <div className="ab_benefit_section_gray section_gray_bottom">
                  <div className="ab_benefit_secont_title_b">
                    ГАРАНТИЯ ЛУЧШЕЙ ЦЕНЫ
                  </div>
                  <div className="ab_benefit_text_b">
                    Если вы найдете готовый тур дешевле, чем у нас, при
                    одинаковых условиях бронирования, TourHunter вернет разницу
                    в двойном размере
                  </div>
                </div>
              </div>
              <div className="ab_benefits_col2">
                <div className="mb_30">
                  <div className="ab_benefit_section_blue ab_benef_top">
                    <img src={Flight} alt="" className="ab_benef_fligh" />
                    <div>
                      <img src={Price} alt="" className="mb_10 ab_ben_ico" />
                      <div className="ab_benefit_title_w">Надежно</div>
                      <div className="ab_benefit_text_w">
                        Больше не нужно обзванивать агентства. Лучшие предложения
                        от всех туроператоров уже ждут вас здесь
                      </div>
                    </div>
                  </div>
                  <div className="ab_triangle">
                    <BlueTriange />
                  </div>
                </div>
                <div className="ab_benefit_section_blue mb_16">
                  <div className="ab_benefit_secont_title_w">
                    ПРОВЕРЕННЫЕ ПАРТНЕРЫ
                  </div>
                  <div className="ab_benefit_text_w">
                    Мы предлагаем туры только от надежных туроператоров (изучаем
                    финансовые показатели, степень ответственности в договорах
                    и как долго оператор на рынке)
                  </div>
                </div>
                <div className="ab_benefit_section_blue">
                  <div className="ab_benefit_secont_title_w">
                    ВАША БЕЗОПАСНОСТЬ НА 1 МЕСТЕ
                  </div>
                  <div className="ab_benefit_text_w">
                    Мы доверили обработку карт лидерам рынка: все платежи по
                    карте проходят через защищенные порталы Альфа-Банка. Деньги
                    попадают на расчетный счет нашей организации!
                  </div>
                </div>
              </div>
              <div className="ab_benefits_col3">
                <div className="mb_30">
                  <div className="ab_benefit_section_gray section_gray_top">
                    <img src={Support} alt="" className="mb_10 ab_ben_ico" />
                    <div className="ab_benefit_title_b">Удобно</div>
                    <div className="ab_benefit_text_b">
                      Запланируйте отдых, а не хлопоты! Мы берем все заботы на
                      себя, чтобы вы могли проводить больше времени с близкими
                    </div>
                  </div>
                  <div className="ab_triangle">
                    <GrayTriange />
                  </div>
                </div>
                <div className="ab_benefit_section_gray mb_16 section_gray_bottom">
                  <div className="ab_benefit_secont_title_b">ВСЕ ОНЛАЙН</div>
                  <div className="ab_benefit_text_b">
                    Оформляйте всё, не выходя из дома
                  </div>
                </div>
                <div className="ab_benefit_section_gray section_gray_bottom">
                  <div className="ab_benefit_secont_title_b">РАБОТАЕМ 24/7</div>
                  <div className="ab_benefit_text_b">
                    Мы на связи. Сопровождаем вас на всех этапах путешествия.
                    Готовы помочь в любой непредвиденной ситуации
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="ab_section_w"
            ref={(node) => {
              this.howToBuyNode.current = node;
            }}
          >
            <div className="ab_section_title">{HOW_TO_BUY}</div>
            <div className="ab_how_to_buy_w">
              <div className="ab_how_to_buy_col1">
                <div className="ab_gray_line ab_gray_line_border"></div>
                {/* step 1 */}
                <div className="ab_how_to_buy_line_left">
                  <div className="ab_how_to_buy_point"></div>
                  <div className="ab_how_to_buy_step">Шаг 1</div>
                  <div className="ab_how_to_buy_title">Выбор тура</div>
                  <div className="ab_how_to_buy_text">
                    Нет ничего проще! Прямо на сайте выбирайте желаемое
                    направление и даты. Используйте диапазон дат вылета — это
                    может оказать магическое действие на цену.
                  </div>
                  <div className="ab_how_to_buy_text">
                    Наш умный алгоритм сравнит цены от 20 туроператоров и покажет
                    все туры на выбранные даты, начиная с самых дешевых
                  </div>
                </div>

                {/* step 2 */}
                <div className="ab_how_to_buy_line_left">
                  <div className="ab_how_to_buy_point"></div>
                  <div className="ab_how_to_spet_pic pic_step_2"></div>
                </div>

                {/* step 3 */}
                <div className="ab_how_to_buy_line_left">
                  <div className="ab_how_to_buy_point"></div>
                  <div className="ab_how_to_buy_step">Шаг 3</div>
                  <div className="ab_how_to_buy_title">Уточнение деталей</div>
                  <div className="ab_how_to_buy_text">
                    Чтобы ничего не упустить, наш менеджер позвонит вам для
                    согласования всех деталей вашего путешествия.
                  </div>
                </div>

                {/* step 4 */}
                <div className="ab_how_to_buy_line_left">
                  <div className="ab_how_to_buy_point"></div>
                  <div className="ab_how_to_spet_pic pic_step_4"></div>
                </div>

                {/* step 5 */}
                <div className="ab_how_to_buy_line_left">
                  <div className="ab_how_to_buy_point"></div>
                  <div className="ab_how_to_buy_step">Шаг 5</div>
                  <div className="ab_how_to_buy_title">
                    Процесс бронирования
                  </div>
                  <div className="ab_how_to_buy_text">
                    По телефону наш менеджер поможет вам окончательно
                    определиться со всеми вопросами. Далее заполняйте данные и
                    переходите к бронированию.
                  </div>
                  <div className="ab_how_to_buy_text">
                    Когда вы оплачиваете тур — деньги сразу не снимаются, они
                    просто блокируются на карте и списываются только в случае
                    окончательного подтверждения тура принимающей стороной.
                  </div>
                </div>

                {/* step 6 */}
                <div className="ab_how_to_buy_line_left">
                  <div className="ab_how_to_buy_point"></div>
                  <div className="ab_how_to_spet_pic pic_step_6"></div>
                </div>

                {/* step 7 */}
                <div className="ab_how_to_buy_line_left ad_how_left_last">
                  <div className="ab_how_to_buy_point"></div>
                  <div className="ab_how_to_buy_step">Шаг 7</div>
                  <div className="ab_how_to_buy_title">Самое главное!</div>
                  <div className="ab_how_to_buy_text">
                    Мы с вами от и до. Наша поддержка не заканчивается после
                    продажи тура. Мы на связи в любой ситуации, где бы вы ни
                    были.
                  </div>
                </div>
              </div>

              {/* right coll */}
              <div className="ab_how_to_buy_col2">
                <div className="ab_gray_line"></div>

                {/* step 1 */}
                <div className="ab_how_to_buy_line_right">
                  <div className="ab_how_to_spet_pic pic_step_1"></div>
                </div>

                {/* step 2 */}
                <div className="ab_how_to_buy_line_right">
                  <div className="ab_how_to_buy_step">Шаг 2</div>
                  <div className="ab_how_to_buy_title">Оформление online</div>
                  <div className="ab_how_to_buy_text">
                    Не нужно никуда ехать, всё оформляется через сайт. Это
                    мгновенно защищает вас от потери выгодной цены и избавляет
                    от поездки в офис. А все платежи мы принимаем через
                    максимально защищённые шлюзы Альфа-Банка — ваши данные под
                    надёжным замком. Оригинал договора придет Вам по почте!
                  </div>
                </div>

                {/* step 3 */}
                <div className="ab_how_to_buy_line_right">
                  <div className="ab_how_to_spet_pic pic_step_3"></div>
                </div>

                {/* step 4 */}
                <div className="ab_how_to_buy_line_right">
                  <div className="ab_how_to_buy_step">Шаг 4</div>
                  <div className="ab_how_to_buy_title">Виза и документы</div>
                  <div className="ab_how_to_buy_text">
                    Если вы едете в страну, где нужна виза — расскажем, какие
                    документы необходимы. Если вы в Минске — отправим к вам
                    курьера за документами и поможем с оформлением.
                  </div>
                </div>

                {/* step 5 */}
                <div className="ab_how_to_buy_line_right">
                  <div className="ab_how_to_spet_pic pic_step_5"></div>
                </div>

                {/* step 6 */}
                <div className="ab_how_to_buy_line_right">
                  <div className="ab_how_to_buy_step">Шаг 6</div>
                  <div className="ab_how_to_buy_title">
                    Все документы — на почту
                  </div>
                  <div className="ab_how_to_buy_text">
                    При оформлении тура мы отправляем Вам оригинал договора с
                    туроператором на подпись по почте. За 2 дня до поездки вы
                    получите все необходимые документы на email (электронные
                    билеты, ваучер, медицинскую страховку и памятку по стране).
                  </div>
                  <div className="ab_how_to_buy_text">
                    Их нужно распечатать и взять с собой. Накануне вылета вам
                    позвонит менеджер и напомнит о времени рейса или сообщит,
                    что время вылета поменялось.
                  </div>
                </div>

                {/* step 7 */}
                <div className="ab_how_to_buy_line_right">
                  <div className="ab_how_to_spet_pic pic_step_7"></div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="ab_section_w"
            ref={(node) => {
              this.ourTeamNode.current = node;
            }}
          >
            <div className="ab_section_title">{KEY_FACES}</div>
            <div className="ab_faces_w">
              <div className="ab_face_col ab_face_col1">
                <div className="ad_face_cont">
                  <div className="ab_face ab_natali_face"></div>
                  <div className="ab_text_w">
                    <div className="ab_face_name">Наталья</div>
                    <div className="ab_face_title">Основатель</div>
                    <div className="ab_face_text">
                      Отвечаю за стратегию и развитие сервиса. Моя цель — чтобы
                      каждый клиент чувствовал себя в путешествии уверенно и
                      спокойно
                    </div>
                  </div>
                </div>
              </div>
              <div className="ab_face_col ab_face_col2">
                <div className="ad_face_cont">
                  <div className="ab_face ab_alex_face"></div>
                  <div className="ab_text_w">
                    <div className="ab_face_name">Алексей</div>
                    <div className="ab_face_title">Сооснователь</div>
                    <div className="ab_face_text">
                      Отвечаю за сервис и технологическую часть. Моя задача —
                      чтобы оформление тура было быстрым и надёжным
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default About;
